const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan2d from './floorplan-2d.jpg';
import floorplan3d from './floorplan-3d.jpg';

const sorted = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const boleslavImages: string[] = sorted;

export const boleslavFloorPlans = [
  { image: floorplan3d, label: "Půdorys bytu – 3D" },
  { image: floorplan2d, label: "Půdorys bytu – 2D" },
];
